export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-open-black/4efc4b9cf8f84a892b46beff0dc40b77.png";